<template>
  <div id="uwfb" class="z-[9999] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">

    <div
      class="flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default"
    >
      <div class="flex gap-4">
        <div
          class="warning flex justify-center items-center flex-shrink-0 w-10 h-10 rounded-sm"
        >
          <WarningIcon />
        </div>
        <div>
          <h2 class="modal-heading">
            {{ changeCase("widget upgraded successfully!", ElementE.TITLE) }}
          </h2>
          <p class="modal-content mt-1">
            {{ changeCase("please publish the changes and insert the new embed code on your website.", ElementE.SUBTITLE) }}
          </p>
        </div>
      </div>

      <div class="pt-2">
        <div class="relative">
          <label @click="copyEmbedCode" class="label-primary flex gap-1 cursor-pointer hover:opacity-80" for="embed-code">
            {{ changeCase("embed code", ElementE.LABEL) }}
            <CopyIcon />
          </label>
          <textarea
            :value="embedCode"
            id="embed-code"
            name=""
            disabled
            rows="5"
            class="w-full text-sm p-3 border border-gray-300 rounded-lg focus:border-red-500 focus:ring-0"
            :placeholder="(changeCase('embed code', ElementE.PLACEHOLDER) as string)"
          ></textarea
          >
        </div>
      </div>

      <div class="self-end">
        <button @click.prevent="updateMe" class="btn-primary is-btn-size-default">
          {{ changeCase("I've updated embed code", ElementE.BUTTON) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import WarningIcon from "../icons/WarningIcon.vue";
import CopyIcon from "@/components/icons/CopyIcon.vue";
import { getEmbedCode } from '@/common/helpers';
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

export default defineComponent({
  name: "UpdateWidgetPopup",
  components: { WarningIcon, CopyIcon },
  emits:['firstUpdateWidget', 'copied'],
  props:{
    widgetId:{
      type: String,
      default: ''
    }
  },
  watch: {
    widgetId: function (widget: string) {
      this.widget = widget;
      this.embedCode = getEmbedCode(this.widget);
    }
  },
  data(){
    return {
      embedCode: '' as string,
      widget: '' as string,

      changeCase: changeCase,
      ElementE: ElementE,
    }
  },
  methods:{
    updateMe(){
      this.$emit('firstUpdateWidget', 1)
      setTimeout(() => {
        window.location.reload()
      }, 500);
    },
    copyEmbedCode: function() {
      this.$emit('copied');
      navigator.clipboard.writeText(this.embedCode);
    }
  },
  mounted() {
    this.widget = this.widgetId;
    this.embedCode = getEmbedCode(this.widget);

  }
});

</script>

<style lang="css" scoped>
#editWidgetFlow{
  opacity: .2;
}

#uwfb{
  opacity: 1 !important;
}
</style>
